import { memo } from 'react'

import LoggedOutPage from './LoggedOutPage'

const LoggedOutPageComponent = memo(LoggedOutPage)

export default LoggedOutPageComponent
